
import { defaultDomicilio, DomicilioProps } from "../comun/DomicilioInterface";
import { defaultDistritoJudicial, DistritoJudicialProps } from "./DistritoJudicialInterface";
import { defaultMateria, MateriaProps } from "./MateriaInterface";

// Definición de defaults

export const defaultAutoridadTitular: AutoridadTitularProps = {
    idAutoridad:            0,
    referenciaPL:           0,
    descripcion:            '',
    idDomicilio:            0,
    domicilio:              defaultDomicilio,
    idMateria:              0,
    materia:                defaultMateria,
    idDistritoJudicial:     0,
    distritoJudicial:       defaultDistritoJudicial,
    activo:                 false,
    idTitular:              0,
    titular:                '',
}

// Creación de interfaces

export interface AutoridadProps{
    idAutoridad:            number;
    referenciaPL?:          number;
    descripcion:            string;
    idDomicilio?:           number;
    domicilio?:             DomicilioProps;
    idMateria:              number;
    materia?:               MateriaProps;
    idDistritoJudicial:     number;
    distritoJudicial?:      DistritoJudicialProps;
    activo:                 boolean;
    idTitular?:             number;
}

export interface AutoridadTitularProps{
    idAutoridad:            number;
    referenciaPL?:          number;
    descripcion:            string;
    idDomicilio?:           number;
    domicilio?:             DomicilioProps;
    idMateria:              number;
    materia?:               MateriaProps;
    idDistritoJudicial:     number;
    distritoJudicial?:      DistritoJudicialProps;
    activo:                 boolean;
    idTitular?:             number;
    titular?:               string;
}

export interface AutoridadDomicilioProps extends DomicilioProps{
    idAutoridad:            number;
}

